import * as tslib_1 from "tslib";
import { InjectionToken } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
// Cloudflare Turnstile zastapil Google reCAPTCHA (te same klucze co na
// zatrzymajlicznik.pl - jedna domena, jeden widget). Interfejs serwisu
// (load/execute/destroy/ready$) pozostal bez zmian, wiec formularze
// uzywaja go identycznie jak wczesniej.
export const TURNSTILE_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
export const TURNSTILE_SITE_KEY = new InjectionToken('TURNSTILE_SITE_KEY', {
    providedIn: 'root',
    factory: () => ''
});
const EXECUTE_TIMEOUT_MS = 30000;
const CONTAINER_ID = 'sc-turnstile-container';
export class CaptchaService {
    constructor(SITE_KEY, platformId) {
        this.SITE_KEY = SITE_KEY;
        this.platformId = platformId;
        this.readySubject = new BehaviorSubject(false);
        this.ready$ = this.readySubject.asObservable();
    }
    get isReady() {
        return this.readySubject.getValue();
    }
    load() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!isPlatformBrowser(this.platformId)) {
                return;
            }
            if (typeof turnstile !== 'undefined') {
                this.readySubject.next(true);
                return;
            }
            return new Promise(resolve => {
                const existing = document.querySelector(`script[src="${TURNSTILE_URL}"]`);
                if (existing) {
                    // Skrypt juz sie laduje (inny formularz) - czekamy na turnstile.
                    const timer = setInterval(() => {
                        if (typeof turnstile !== 'undefined') {
                            clearInterval(timer);
                            this.readySubject.next(true);
                            resolve();
                        }
                    }, 100);
                    return;
                }
                const script = document.createElement('script');
                script.type = 'text/javascript';
                script.async = true;
                script.defer = true;
                script.onload = () => {
                    this.readySubject.next(true);
                    resolve();
                };
                script.src = TURNSTILE_URL;
                document.body.appendChild(script);
            });
        });
    }
    // Kazde wywolanie renderuje swiezy widget (token Turnstile jest
    // jednorazowy i wygasa po 300 s) i zwraca token po rozwiazaniu.
    // Widget jest niewidoczny (interaction-only); gdy Cloudflare zazada
    // interakcji, pojawia sie w prawym dolnym rogu.
    execute() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!isPlatformBrowser(this.platformId) ||
                typeof turnstile === 'undefined') {
                return '';
            }
            return new Promise((resolve, reject) => {
                const container = this.getContainer();
                let widgetId;
                const timer = setTimeout(() => {
                    cleanup();
                    reject(new Error('turnstile timeout'));
                }, EXECUTE_TIMEOUT_MS);
                const cleanup = () => {
                    clearTimeout(timer);
                    try {
                        turnstile.remove(widgetId);
                    }
                    catch (e) { }
                };
                widgetId = turnstile.render(container, {
                    sitekey: this.SITE_KEY,
                    appearance: 'interaction-only',
                    callback: (token) => {
                        cleanup();
                        resolve(token);
                    },
                    'error-callback': () => {
                        cleanup();
                        reject(new Error('turnstile error'));
                    },
                    'expired-callback': () => {
                        cleanup();
                        reject(new Error('turnstile expired'));
                    }
                });
            });
        });
    }
    destroy() {
        try {
            const container = document.getElementById(CONTAINER_ID);
            if (container) {
                container.remove();
            }
        }
        catch (e) { }
    }
    getContainer() {
        let container = document.getElementById(CONTAINER_ID);
        if (!container) {
            container = document.createElement('div');
            container.id = CONTAINER_ID;
            container.style.position = 'fixed';
            container.style.bottom = '16px';
            container.style.right = '16px';
            container.style.zIndex = '2147483647';
            document.body.appendChild(container);
        }
        return container;
    }
}
